import { uploadFilesRequest } from "@dreebit-registry/vsm-microservice-components";

/**
 * Uploads one file to the file service (`POST /file`) and returns its UUID —
 * the value `imageId` / `fileServiceUuid` expect. Rejects when the service
 * answers without an id (e.g. an HTML error page, which `uploadFilesRequest`
 * does not check for itself).
 */
export const uploadSingleFile = async (file: File, token?: string): Promise<string> => {
    const uploaded = await uploadFilesRequest([file], token);
    const fileId = uploaded?.[0]?.fileId;
    if (!fileId) {
        throw new Error('File upload returned no file id');
    }
    return fileId as string;
};
